import { AUTOMATED_EXECUTION_USER } from '@qality/common-components/src/picker/UserPicker';
import { User } from '@qality/common-model';
import {
  StorageOfUniqueModels,
  StorageOfUniqueServices,
} from '@qality/common-service';

export default {
  createRemovedUser(): User {
    const UserType = StorageOfUniqueModels.get('User');
    return new UserType({
      displayName: 'Removed user',
      [UserType.getIdentifierName()]: 'removed_user',
    });
  },
  createAnonymousUser(): User {
    const UserType = StorageOfUniqueModels.get('User');
    return new UserType({
      displayName: 'Anonymous user',
      [UserType.getIdentifierName()]: 'anonymous_user',
    });
  },
  createSomeUser(): User {
    const UserType = StorageOfUniqueModels.get('User');
    return new UserType({
      displayName: 'Some user',
      [UserType.getIdentifierName()]: 'some_user',
    });
  },
  createUnassignedUser(): User {
    const UserType = StorageOfUniqueModels.get('User');
    return new UserType({
      displayName: 'Unassigned user',
      [UserType.getIdentifierName()]: null,
    });
  },
  createAutomatedExecutionUser(): User {
    const UserType = StorageOfUniqueModels.get('User');
    const iconUrl =
      StorageOfUniqueServices.get('URLService').getQAlityIssueIcon();

    return new UserType({
      displayName: AUTOMATED_EXECUTION_USER.label,
      [UserType.getIdentifierName()]: AUTOMATED_EXECUTION_USER.value,
      avatarUrls: {
        '24x24': iconUrl,
        '16x16': iconUrl,
      },
    });
  },
};
